var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInfoSuperBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 74,
    height: 74,
    rx: 37,
    fill: "url(#paint0_linear)",
    fillOpacity: 0.05
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.332 28.6673H42.6654V32.0007H39.332V28.6673ZM39.332 35.334H42.6654V45.334H39.332V35.334ZM40.9987 20.334C31.7987 20.334 24.332 27.8007 24.332 37.0007C24.332 46.2007 31.7987 53.6673 40.9987 53.6673C50.1987 53.6673 57.6654 46.2007 57.6654 37.0007C57.6654 27.8007 50.1987 20.334 40.9987 20.334ZM40.9987 50.334C33.6487 50.334 27.6654 44.3507 27.6654 37.0007C27.6654 29.6507 33.6487 23.6673 40.9987 23.6673C48.3487 23.6673 54.332 29.6507 54.332 37.0007C54.332 44.3507 48.3487 50.334 40.9987 50.334Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInfoSuperBigCircle);
export default __webpack_public_path__ + "static/media/ic_info_super_big_circle.1ee0e9167e464d0d06a73046b361115b.svg";
export { ForwardRef as ReactComponent };